"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var compareClientRectWithViewport = function (rect) {
    var vWidth = window.innerWidth || document.documentElement.clientWidth;
    var vHeight = window.innerHeight || document.documentElement.clientHeight;
    var exceedTop = rect.top < 0 ? -rect.top : 0;
    var exceedLeft = rect.left < 0 ? -rect.left : 0;
    var exceedBottom = rect.bottom > vHeight ? rect.bottom - vHeight : 0;
    var exceedRight = rect.right > vWidth ? rect.right - vWidth : 0;
    return {
        exceedTop: exceedTop,
        exceedBottom: exceedBottom,
        exceedLeft: exceedLeft,
        exceedRight: exceedRight,
    };
};
exports.default = compareClientRectWithViewport;
//# sourceMappingURL=compareClientRectWithViewport.js.map